import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Home, List } from "lucide-react";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-lg mx-4 shadow-sm border border-slate-200">
        <CardContent className="pt-8 pb-8">
          <div className="flex mb-4 gap-3 items-start">
            <AlertCircle className="h-8 w-8 text-red-500 shrink-0" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Página no encontrada</h1>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                La URL que has solicitado no existe o ha sido movida. Puedes volver al inicio
                o explorar nuestros artículos estadísticos.
              </p>
            </div>
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <Link
              href="/"
              className="inline-flex flex-1 items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90 min-h-[44px]"
            >
              <Home className="w-4 h-4 mr-2" />
              Ir al inicio
            </Link>
            <Link
              href="/statistics-list"
              className="inline-flex flex-1 items-center justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 min-h-[44px]"
            >
              <List className="w-4 h-4 mr-2" />
              Ver artículos
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
